export default __webpack_public_path__ + "static/media/undraw_Location_search_re_ttoj.1f28f250.svg";